import React from 'react';
import ReactClass from 'create-react-class';
import Parse from 'parse';
import UserRow from './userRow';
import ModalUser from './modalUser';
import {Button, Glyphicon,} from 'react-bootstrap';

export default ReactClass({

    getInitialState() {
        return {
            users: [],
            showModal: false,
        }
    },

    fetchProjectList() {

        let _this = this;
        let User = Parse.Object.extend("User");
        let aliases = [];

        let usersQuery = new Parse.Query(User);
        usersQuery.include("info");

        usersQuery.find().then((results) => {

            let users = [];
            results.forEach((user, i) => {
                let info = user.get("info");
                if(info !== undefined && info.get("deleted") !== true) {
                    let aliasesString = "-";
                    if (Array.isArray(info.get("aliases"))){
                        aliasesString = info.get("aliases").join(", ");
                        aliases.push(...info.get("aliases"));
                    }

                    users.push({
                        object: info,
                        id: user.id,
                        email: user.get("username"),
                        name: info.get("name"),
                        phone: info.get("phone"),
                        aliases: aliasesString
                    });
                } else {

                }
            });

            _this.setState({
                users: users.sort((a,b) => { return a.name.localeCompare(b.name) }),
                aliases
            });

        });

    },

    componentDidMount() {
        this.fetchProjectList()
    },
    newUser() {
        this.setState({showModal: true});
    },
    closeModal(user, info) {
        if(user !== undefined && user.id !== undefined) {
            let users = this.state.users || [];
            users.push({
                object: info,
                id: user.id,
                email: user.get("username"),
                name: info.get("name"),
                phone: info.get("phone"),
                aliases: Array.isArray(info.get("aliases")) ? info.get("aliases").join(", ") : "-"
            });
            this.setState({users: users, showModal: false});
        } else {
            this.setState({showModal: false});
        }
    },

    render() {
        return (
            <div>
                <h2>
                    Users
                    <Button bsStyle="primary" bsSize="small" className="pull-right" onClick={this.newUser}>
                        <Glyphicon glyph="plus"/>&nbsp;
                        New user
                    </Button>
                </h2>
                {
                    this.state.users.length > 0 ? (
                        <table className="table table-striped users">
                            <thead>
                            <tr>
                                <th>Name</th>
                                <th style={{width: "15%"}}>Aliases</th>
                                <th style={{width: "25%"}}>E-mail</th>
                                <th style={{width: "20%"}}>Phone number</th>
                                <th style={{width: 140}}>Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.users.map((user) => {
                                return (
                                    <UserRow key={user.id} user={user} />
                                );
                            })}
                            </tbody>
                        </table>
                    ) : (
                        <em>No users found.<br /><br /></em>
                    )
                }
                <ModalUser show={this.state.showModal} skipAliases={this.state.aliases} close={this.closeModal} />
            </div>
        );
    },

});


// WEBPACK FOOTER //
// ./src/users.js